import React from "react";
import { View } from "react-native";
import { Heading, Text, theme } from "@clearabee/ui-library-native";
import { LinearGradient } from "expo-linear-gradient";
import { horizontalStyles as styles } from "./Train.styles";
import { TrainItemIcon } from "./TrainItemIcon";
import { getGradientColors, useTrainContext } from "./Train.utils";
import type { TrainItemProps } from "./Train.types";

export const TrainItemHorizontal = ({
  icon,
  title,
  description,
}: TrainItemProps): React.ReactElement => {
  const {
    titleSize,
    position: { previous, current, next },
  } = useTrainContext();
  const gradientColors = getGradientColors(
    current.active,
    current.complete,
    next.active,
  );
  const previousColor = getGradientColors(
    previous.active,
    previous.complete,
    current.active,
  ).slice(-1)[0];
  const nextColor = gradientColors[0];

  return (
    <>
      <View style={!!description && { flex: 2 }}>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <View
            style={[
              styles.gradient,
              { flex: 1 },
              !current.first && { backgroundColor: previousColor },
            ]}
          />

          <View style={{ alignSelf: "center" }}>
            <TrainItemIcon icon={icon} />
          </View>

          <View
            style={[
              styles.gradient,
              { flex: 1 },
              !current.last && { backgroundColor: nextColor },
            ]}
          />
        </View>

        <Heading
          level={5}
          fontSize={titleSize}
          numberOfLines={1}
          styles={styles.heading}
        >
          {title}
        </Heading>
        {description && (
          <Text fontSize="small" styles={styles.description}>
            {description}
          </Text>
        )}
      </View>

      {!current.last && (
        <View style={{ flex: 1 }}>
          <View>
            <View style={{ alignSelf: "flex-start", opacity: 0 }}>
              <TrainItemIcon icon={icon} />
            </View>

            <View style={styles.gradientWrapper}>
              <LinearGradient
                colors={gradientColors}
                start={{ x: 0, y: 1 }}
                end={{ x: 1, y: 0 }}
                style={styles.gradient}
              />
            </View>
          </View>
        </View>
      )}
    </>
  );
};
